import React, { useContext } from 'react';
import DailyActiveUsersContext from '../../../../contexts/DailyActiveUsersContext';
import { ConsolidatedHeaderComponent } from '../../components/Metrics/ConsolidatedHeader/ConsolidatedHeaderComponent';
import { useDauConsumptionContext } from '../../../../contexts/Billing/DauConsumptionContext';

const CompiledDailyActiveUserTitleComponent: React.FC = () => {
  const { dateToSearch, currentMonth, content } = useContext(DailyActiveUsersContext);
  const { compiledDailyActiveUserDataState } = useDauConsumptionContext();
  const quantity = compiledDailyActiveUserDataState.compiledDailyActiveUserConsumption.metric.quantity;
  const compiledContainsDataOnSelectedMonth = compiledDailyActiveUserDataState.compiledContainsDataOnSelectedMonth;

  return (
    <ConsolidatedHeaderComponent
      infoHeader={content.compiledDailyActiveUserInformation.plan}
      dateToSearch={dateToSearch}
      currentMonth={currentMonth}
      middleInfoContent={content.compiledDailyActiveUserInformation.middleInfo}
      showConsolidatedBorder={false}
    />
  );
};

export default CompiledDailyActiveUserTitleComponent;
